import React from 'react'
import { useContext } from './Context'
import { BoardItem } from './BoardItem'
import { AccountContainer } from '../../AccountContainer'
import { EmptyContent } from '../EmptyContent'
import { DataSuspense } from '@ztechapps/webui.util'
import { PageTitle } from '../../../../components/PageTitle'

export const Layout = () => {
  const { document, loading, error } = useContext()
  const boardTitle = document?.name ? `Board: ${document.name}` : 'Board Details'
  const boardDescription = document?.description || 'View and manage your project board'

  return (
    <AccountContainer>
      <PageTitle title={boardTitle} description={boardDescription} />
      <DataSuspense error={error} loading={loading} isEmpty={!document} emptyComponent={<EmptyContent />}>
        <BoardItem />
      </DataSuspense>
    </AccountContainer>
  )
}
